import axios from "axios";
import { setChechSum, getAccessTkn, getRefreshTkn, setLocalAccessToknen, setLocalRefreshToken, getUserData, getBankData } from "./common";
import * as urls from "./urlConst";
import { getBrowserDetails } from "./common";
import { exceptionLog } from "./common";
const packageJson = require("./../../../package.json");

const currentVersion = packageJson.version;
var getChecksumValue: any = null;

const axiosInstance = axios.create({
    baseURL: window?.globalConfig.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        'Authorization': 'Basic ' + btoa(process.env.REACT_APP_AUTHENTICATION_USERNAME + ':' + process.env.REACT_APP_AUTHENTICATION_PASSWORD),
    }
});

axiosInstance.interceptors.request.use(
    (config) => {
        if (getChecksumValue) {
            config.headers["checksum"] = getChecksumValue;
        }

        const accessToken = getAccessTkn();
        if (accessToken) {
            config.headers["Authorization"] = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },

    async (error: any) => {

        if (!error.response) {
            window.location.href = '/';
            return Promise.reject(error);
        }

        const originalRequest = error.config;

        if (error.response.status === 403 && !originalRequest._retry) {
            originalRequest._retry = true;

            const refreshToken = getRefreshTkn();
            await refreshAccessToken(refreshToken);

            // retry the original request with the new access token
            return axiosInstance(originalRequest);
        };

        return Promise.reject(error);
    },
);

// Function to refresh access token using your authentication service
const refreshAccessToken = async (refreshToken: string) => {
    const payload = {
        Domain: window.location.hostname,
        RefreshToken: refreshToken
    };

    await axios({
        method: "POST",
        url: urls.refreshTkn,
        data: payload,
        headers: {
            "Content-Type": "application/json",
            'Authorization': 'Basic ' + btoa(process.env.REACT_APP_AUTHENTICATION_USERNAME + ':' + process.env.REACT_APP_AUTHENTICATION_PASSWORD),
        },
    }).then((response) => {
        // if (response.data.Success) {
        setLocalAccessToknen(response.data.JwtToken);
        setLocalRefreshToken(response.data.RefreshToken);
        // }
    }).catch(async (error) => {
        window.location.href = "/sessionout";
    });
};

export const makeRequest = async (
    method: any,
    endpoint: any,
    data: any = null,
    config = {}) => {

    const getLocation: any = localStorage.getItem("location");
    const location = JSON.parse(getLocation);
    const getidentifyData: any = localStorage.getItem("_identityData");
    const identifyData = JSON.parse(getidentifyData);
    const browserDtl = getBrowserDetails();
    const userData = getUserData();
    const bankDtl: any = getBankData();

    try {
        const payload = {
            ...data,
            BankCode: data?.BankCode || userData?.BankCode || "",
            Token: data?.Token || userData?.SessionToken || "",
            UserId: userData?.TranCode || "",
            UserName: bankDtl.ClientLoginType !== "Y" ? (data?.UserName || userData?.MobileNo) : (data?.UserName || userData?.UserName) || "",
            Domain: window.location.hostname,
            IpAddress: identifyData.ip,
            Imei: "N/A",
            Version: currentVersion,
            Device: "Web",
            Channel: "Web",
            DeviceIpv6: "N/A",
            DeviceId: "N/A",
            DeviceMac: 'N/A',
            DeviceName: browserDtl.os.name,
            DeviceUserName: 'N/A',
            Latitude: location?.latitude.toString() || "",
            Longitude: location?.longitude.toString() || "",
            Browser: browserDtl.browser.name
        };
        const checksum = setChechSum(JSON.stringify(payload));

        const response = await axiosInstance({
            method,
            url: endpoint,
            data: payload,
            ...{
                ...config,
                headers: {
                    checksum: checksum,
                },
            },
        });

        //Handle successful reposnse
        if (response.data.STATUS === "3" || response.data.STATUS === "6") {
            return window.location.href = "/sessionout";
        } else {
            return response.data;
        }

    } catch (error: any) {
        await exceptionLog(error, "Error making request", "Y");
        throw new Error(error);
    }
};
